import getTranslationFromTransportType
    from "@SearchResults/features/staticContent/functions/getTranslationFromTransportType";
import {TransportTypesType} from "@SearchResults/types/TransportTypes.type";

export default function createAvailableOperatorsList(transportTypes: TransportTypesType[]) {
    const availableVehClasses = transportTypes.map((transportType) => (
        getTranslationFromTransportType(transportType)
    ))

    return (
        `${availableVehClasses.slice(0, availableVehClasses.length - 1).join(", ")} and ${availableVehClasses[availableVehClasses.length - 1]}`
    )
}